import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from '@cloudscape-design/components';
import AppealsPage from './AppealsPage';
import './AppealsPage.css';

export default function FloatingAppealWindow() {
  const location = useLocation();
  const history = useHistory();
  const caseId = /^\/(?:application-case|cases)\/(\d+)(?:\/|$)/.exec(location.pathname)?.[1];
  const requested = new URLSearchParams(location.search).get('appeal');
  const [current, setCurrent] = useState(null);
  const [minimised, setMinimised] = useState(false);
  const [lodging, setLodging] = useState(false);
  const [openRequestId, setOpenRequestId] = useState(0);

  useEffect(() => {
    if (!caseId || /\/appeals\/?$/.test(location.pathname)) { setCurrent(null); return; }
    if (requested) {
      setCurrent(previous => previous?.caseId === caseId && previous.appealId === requested ? previous : { caseId, appealId: requested });
      setMinimised(false);
    } else {
      setCurrent(previous => previous?.caseId === caseId ? previous : null);
    }
  }, [caseId, requested, location.pathname]);

  const select = useCallback(appealId => {
    const params = new URLSearchParams(location.search);
    params.set('appeal', appealId);
    history.replace({ ...location, search: `?${params}` });
    setMinimised(false);
  }, [history, location]);
  useEffect(() => {
    const open = event => {
      if (caseId && String(event.detail?.caseId) === caseId) { select(event.detail.appealId || 'open'); setOpenRequestId(value => value + 1); }
    };
    window.addEventListener('appeals:open', open);
    return () => window.removeEventListener('appeals:open', open);
  }, [caseId, select]);

  const close = () => {
    setCurrent(null);
    const params = new URLSearchParams(location.search);
    params.delete('appeal');
    history.replace({ ...location, search: params.toString() ? `?${params}` : '' });
  };
  // Never leave another participant's appeal floating over the next case.
  if (!current || current.caseId !== caseId) return null;
  const title = lodging ? 'Lodge an appeal' : 'Review appeal';
  return <section className={`appeal-window${minimised ? ' appeal-window--minimised' : ''}`} role="dialog" aria-modal="false" aria-label={title}>
    <div className="appeal-window__header">
      <strong>{title}</strong>
      <div className="appeal-page__actions">
        <Button variant="icon" iconName={minimised ? 'angle-up' : 'angle-down'} ariaLabel={minimised ? 'Restore appeal' : 'Minimise appeal'} onClick={() => setMinimised(value => !value)} />
        <Button variant="icon" iconName="close" ariaLabel="Close appeal" onClick={close} />
      </div>
    </div>
    <div className="appeal-window__body" hidden={minimised}>
      <AppealsPage key={`${current.caseId}:${current.appealId}`} embedded openRequestId={openRequestId} caseIdOverride={current.caseId} appealId={current.appealId} onSelected={select} onLodgingChange={setLodging} />
    </div>
  </section>;
}
